import React, { useState, createContext } from 'react';
export var DownloadContext = createContext(undefined);
var DownloadProvider = function (_a) {
    var children = _a.children;
    var _b = useState(), downloadsData = _b[0], setDownloadsData = _b[1];
    var _c = useState(), downloadsError = _c[0], setDownloadsError = _c[1];
    var _d = useState(false), downloadsLoaded = _d[0], setDownloadsLoaded = _d[1];
    return (React.createElement(DownloadContext.Provider, { value: {
            downloadsData: downloadsData,
            downloadsError: downloadsError,
            downloadsLoaded: downloadsLoaded,
            setDownloadsData: setDownloadsData,
            setDownloadsError: setDownloadsError,
            setDownloadsLoaded: setDownloadsLoaded,
        } }, children));
};
export default DownloadProvider;
